import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../configs/store';
import Form from '../../Form/Form';

interface AccountConfirmationProps {
  confirmAccount: () => void,
  close: () => void,
  accountConfirmed: boolean
}

function AccountConfirmation({ close }: AccountConfirmationProps) {
  const { t } = useTranslation('common');
  const history = useHistory();
  const { accountConfirmed } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const closeFunction = (e: KeyboardEvent) => {
    if (e.key === 'Enter') close();
  };

  useEffect(() => {
    document.addEventListener('keydown', closeFunction);

    return () => {
      document.removeEventListener('keydown', closeFunction);
    };
  });

  useEffect(() => {
    dispatch.auth.confirmAccount();

    if (accountConfirmed) {
      history.push('#login');
    }
  }, [accountConfirmed]); // eslint-disable-line react-hooks/exhaustive-deps

  const steps = [
    {
      buttons: [
        {
          type: 'submit',
          label: t('form.letsPlay')
        }
      ]
    }
  ];

  return (
    <Form
      containerClass="accountConfirmation-form"
      steps={ steps }
      close={ close }
    />
  );
}

export default AccountConfirmation;
